import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ac7aa79"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-layout shadow" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = {
  key: 0,
  class: "reload-error"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-redo cursor-pointer fs-3 color-icon" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-error" }, "Error Api", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

import { LineChart } from 'vue-chart-3'
import { Chart, registerables } from 'chart.js'
import { translate } from '@/languages/i18n'
// 2022/10/26 CW-NamPH Fix UAT#4534: CB10 (Ph2-R20221028)
import { ref, watch, PropType } from 'vue'
// 2022/10/26 CW-NamPH Fix UAT#4534: CB10 (Ph2-R20221028)

export default /*#__PURE__*/_defineComponent({
  props: {
  // step: {
  //   type: Number,
  // },
  labelCharts: {
    type: Array,
  },
  dataChart: Array as PropType<{ dataAlumnus?: Array; dataEmployees?: Array; dataCommunityAdmin?: Array }>,
  title: {
    type: String,
  },
  // 2022/11/01 CW-PhuongTT Fix UAT#4952: CB10 (Ph2-R20221104)
  // titleChart: {
  //   type: String,
  // },
  loading: {
    type: Boolean,
    default: true,
  },
  errorCallApi: {
    type: Boolean,
  },
  getDataChart: {
    type: Function,
  },
  date: {
    type: Object,
  },
},
  setup(__props) {

const props = __props

Chart.register(...registerables)


const data = ref({
  labels: [],
  datasets: [],
})

watch(
  () => props.loading,
  () => {
    if (!props.loading) {
      data.value.labels = props?.labelCharts
      data.value.datasets = setDataChart()
    }
  }
)

watch(
  () => props.date?.from,
  () => {
    data.value.labels = props?.labelCharts
    data.value.datasets = setDataChart()
  }
)
watch(
  () => props.date?.to,
  () => {
    data.value.labels = props?.labelCharts
    data.value.datasets = setDataChart()
  }
)

const setDataChart = () => {
  if (props?.dataChart?.dataAlumnus && props?.dataChart?.dataEmployees) {
    return [
      {
        label: translate('almunai'),
        data: props?.dataChart?.dataAlumnus,
        fill: false,
        borderColor: '#78D64B',
        backgroundColor: 'rgb(120 214 75 / 50%)',
        tension: 0.1,
      },
      {
        label: translate('CB10enrollUser2'),
        data: props?.dataChart?.dataEmployees,
        fill: false,
        borderColor: '#FFAD00',
        backgroundColor: 'rgb(255 173 0 / 50%)',
        tension: 0.1,
      },
    ]
  }
  if (props?.dataChart?.dataAlumnus) {
    return [
      {
        label: translate('almunai'),
        data: props?.dataChart?.dataAlumnus,
        borderColor: '#78D64B',
        backgroundColor: 'rgb(120 214 75 / 50%)',
      },
    ]
  }
  if (props?.dataChart?.dataCommunityAdmin) {
    return [
      {
        label: translate('CB10enrollUser'),
        data: props?.dataChart?.dataCommunityAdmin,
        borderColor: 'rgba(253,0,0,0.5)',
        backgroundColor: 'rgba(253,0,0,0.3)',
      },
    ]
  }
}

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: true,
      text: props.titleChart,
    },
  },
  scales: {
    y: {
      min: 0,
      // 2022/10/26 CW-NamPH Fix UAT#4534: CB10 (Ph2-R20221028)
      // max: '',
      suggestedMax: 10,
      // 2022/10/26 CW-NamPH Fix UAT#4534: CB10 (Ph2-R20221028)
      // ticks: {
      //   stepSize: props.step,
      // },
    },
    x: {
      grid: {
        drawBorder: false,
        color: '#ffffff',
      },
    },
  },
}
// 2022/10/26 CW-NamPH Fix UAT#4534: CB10 (Ph2-R20221028)
// watchEffect(() => {
//   if (props?.dataChart?.dataAlumnus && props?.dataChart?.dataEmployees) {
//     if (Math.max(...props?.dataChart?.dataAlumnus) < 160 && Math.max(...props?.dataChart?.dataEmployees) < 160) {
//       options.scales.y.max = 160
//     } else {
//       Math.max(...props?.dataChart?.dataAlumnus) > Math.max(...props?.dataChart?.dataEmployees)
//         ? (options.scales.y.max = Math.max(...props?.dataChart?.dataAlumnus))
//         : (options.scales.y.max = Math.max(...props?.dataChart?.dataEmployees))
//     }
//   } else if (props?.dataChart?.dataAlumnus) {
//     if (Math.max(...props?.dataChart?.dataAlumnus) < 160) {
//       options.scales.y.max = 160
//     } else {
//       options.scales.y.max = Math.max(...props?.dataChart?.dataAlumnus)
//     }
//   } else {
//     if (Math.max(...props?.dataChart?.dataCommunityAdmin) < 160) {
//       options.scales.y.max = 160
//     } else {
//       options.scales.y.max = Math.max(...props?.dataChart?.dataCommunityAdmin)
//     }
//   }
// })
// 2022/10/26 CW-NamPH Fix UAT#4534: CB10 (Ph2-R20221028)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(__props.title), 1),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (__props.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : _createCommentVNode("", true),
      (!__props.loading && __props.errorCallApi)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.getDataChart && __props.getDataChart(...args))),
            class: "reload-error"
          }, _hoisted_9))
        : _createCommentVNode("", true)
    ]),
    (!__props.loading && !__props.errorCallApi)
      ? (_openBlock(), _createBlock(_unref(LineChart), {
          key: 0,
          class: "chart m-auto",
          chartData: data.value,
          options: options
        }, null, 8, ["chartData"]))
      : _createCommentVNode("", true)
  ]))
}
}

})